var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CSV_COLUMNS } from "../constants/csv.constants";
function escapeCsvCell(value) {
    var hasDangerousCharacters = /[",\r\n]/.test(value);
    if (hasDangerousCharacters) {
        return "\"".concat(value.replace(/"/g, '""'), "\"");
    }
    return value;
}
export function mapResponseToCsvRow(response) {
    var _a, _b;
    return {
        userId: (_a = response.userId) !== null && _a !== void 0 ? _a : "",
        submittedAt: response.submittedAt,
        serviceSlug: (_b = response.serviceSlug) !== null && _b !== void 0 ? _b : "",
        answers: JSON.stringify(response.answers),
    };
}
export function generateCsv(rows) {
    var header = CSV_COLUMNS.join(",");
    var lines = rows.map(function (row) {
        return CSV_COLUMNS.map(function (col) { return escapeCsvCell(row[col]); }).join(",");
    });
    return __spreadArray([header], lines, true).join("\r\n");
}
export function downloadCsv(content, filename) {
    var blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
